<script setup lang="ts">
  import { Select } from "primevue";
  import Message from "@/ui/message/message.vue";
  import { useField } from "vee-validate";
  import { useAttrs } from "vue";

  // @ts-ignore
  Select.compatConfig = {
    MODE: 3,
  };

  const props = withDefaults(
    defineProps<{
      name: string;
      label: string;
      required?: boolean;
      optionLabel?: string;
      optionValue?: string;
      classes?: { select: string; label: string };
    }>(),
    {
      required: false,
    },
  );
  const attrs = useAttrs();

  const { value: localValue, errorMessage } = useField(() => props.name);
</script>
<script lang="ts">
  export default {
    compatConfig: {
      MODE: 3,
    },
  };
</script>

<template>
  <div class="flex flex-col gap-1">
    <label v-if="label" :for="name" :class="['text-[14px] font-normal', classes?.label]">
      {{ label }}
      <span v-if="required" class="text-[#FF55C6]">*</span>
    </label>
    <Select
      v-bind="attrs"
      :labelId="name"
      v-model="localValue"
      :name="name"
      :invalid="!!errorMessage"
      :option-label="optionLabel"
      :option-value="optionValue"
      :class="['h-[40px]', classes?.select]"
    ></Select>
    <Message v-if="errorMessage" severity="error" size="small" variant="simple" :text="errorMessage" />
  </div>
</template>
